import { render } from "./VatIdCheck.vue?vue&type=template&id=0b1e2322"
import script from "./VatIdCheck.vue?vue&type=script&lang=js"
export * from "./VatIdCheck.vue?vue&type=script&lang=js"

import "./VatIdCheck.vue?vue&type=style&index=0&id=0b1e2322&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__